module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.foreign.nameShort ? _vm.foreign.nameShort : _vm.formats.blank(_vm.foreign.name, function (v) { return v.slice(0, 30) + '...'; })) + "\n          ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foreign && _vm.foreign.id),
      expression: "foreign && foreign.id"
    }],
    attrs: {
      "flat": "",
      "md": "",
      "offset": _vm.calcOffset(0, 0)
    }
  }, [_c('v-card-text', [_c('div', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.name)))])]), _vm._v(" "), _c('div', [_vm._v("Страна: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.countryName)))]), _vm._v(" Код страны: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.countryCode)))])]), _vm._v(" "), _c('div', [_vm._v("Адрес: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.address)))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v("Дата регистрации: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.regDate, _vm.formats.formatDate)))])]), _vm._v(" "), _c('div', [_vm._v("Регистрирующая организация: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.regOrgName)))])]), _vm._v(" "), _c('div', [_vm._v("Регистрационный номер: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.regNumber)))])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37843f0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/ForeignPage.vue
// module id = 1102
// module chunks = 1